var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-default-color"},[_c('equipment-toolbar',{attrs:{"heading":"Fleet Tracking"}},[_c('equipment-list-nav-tabs')],1),_c('div',[_c('vue-map',{attrs:{"center":{
				lat: +_vm.$store.company.lat,
				lng: +_vm.$store.company.long
			},"zoom":9,"markers":_vm.equipmentMarkers,"map-size":"map-lg"}}),_c('table-list',{attrs:{"record-name":"Equipment","fields":[
				{label: 'Equipment',key: 'equipmentDescription', type: 'link'},
				{label: 'Type',key: 'equipmentType'},
				{label: 'Status',key: 'status'},
				{label: 'Assigned To', key: 'userAssignedTo'},
				{label: 'Clocked Into', key: 'userClockedInto'},
				{label: 'Speed',key: 'speedKm'},
				{label: 'Fuel Level',key: 'fuelLevel'},
			],"records":_vm.mutatedFleetGeo,"has-edit":"/equipment/item/{?}/location","edit-button-text":"View","id-field":"slug"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }